export default __webpack_public_path__ + "static/media/cny-angbao-bonus.93a62574.webp";